const zhTW = {
    crossmintPayButtonService: {
        CONNECTING: "連接中...",
        BUY: "用Crossmint購買",
        BUY_WITH_ETH: "用ETH購買",
        BUY_WITH_SOL: "用SOL購買",
        BUY_WITH_CREDIT_CARD: "用信用卡購買",
    },
};
export default zhTW;
